import { Component, Input, OnInit } from '@angular/core';
import { Headers } from '@angular/http';
import { SharedService } from "./shared.service";
import { ConfigService } from './service/config.service';
import { WindowRefService } from './service/windowRef.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare function getUrlTokenServiceIframe(): any;

@Component({
  selector: 'login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./bar.component.css'],
  providers: [ConfigService]
})

export class LoginComponent implements OnInit {

  @Input() loginMessage: string;

  loginDisabled: boolean;
  objLoaderStatus: boolean;
  authurl: string;
  tokenServiceFolder: string;

  urlSafe: SafeResourceUrl;
  iframeBaseUrl: string;

  domains: any[];

  wheelHandler: any;

  constructor(private sharedService: SharedService,
    private _configService: ConfigService,
    private winRef: WindowRefService,
    public sanitizer: DomSanitizer) {

    let that = this;

    that.objLoaderStatus = false;

    that.sharedService.authInfoEvent.subscribe(authInfoData => {
      let domains = authInfoData.domains;
      that.domains = domains;

      localStorage.setItem('authInfo', JSON.stringify(that.domains[0]));
      that.authurl = that.domains[0].authurl;
    });

  }

  ngOnInit() {
    let that = this;
    that.loginDisabled = true;
    that.wheelHandler = that.receiveMessage.bind(that);

    if (JSON.parse(localStorage.getItem('config'))['newAuthenticationManagement']) {
      that.sharedService.authInfo();
    }
       
    this.sharedService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
  }

  public getTourPlan(id, pw) {
    this.sharedService.displayLoader(true);

    const headers = new Headers();
    headers.append('Authorization', 'Basic ' + btoa(id + ":" + pw));
    headers.append('App-Agent', 'tpl');
    headers.append('domain', JSON.parse(localStorage.getItem('authInfo')).domain);

    this.sharedService.login(headers, id, pw);

    this.reload();

  }

  public onLoginButtonClick() {
    let that = this;

    that.sharedService.displayLoader(true);
    if (JSON.parse(localStorage.getItem('authInfo')) && JSON.parse(localStorage.getItem('authInfo')).authurl) {
      let confUrlObj = getUrlTokenServiceIframe();

      that.tokenServiceFolder = confUrlObj.tokenServiceFolder;
      let directoryName = confUrlObj.directoryName;
      let htmlPath = confUrlObj.htmlPath;

      const srcIframe = that.tokenServiceFolder + 'TokenService.svc/v1/Dispatcher?origin=' + window.location.origin + '&application=speedytouch';

      const pathArray = srcIframe.split('/');
      const protocol = pathArray[0];
      const host = pathArray[2];

      that.iframeBaseUrl = protocol + '//' + host;


      that.sharedService.createIframeTokenService(that.wheelHandler, srcIframe);

      setTimeout(function () {
        that.objLoaderStatus = false;
      }, 3000);
    }
  }

  receiveMessage: any = (e: any) => {
    let that = this;

    const key = e.message ? 'message' : 'data';
    const data = e[key];

    that.objLoaderStatus = false;

    if (e.origin == that.iframeBaseUrl && data) {
      localStorage.setItem('signature', data);

      that.sharedService.displayLoader(true);

      window.removeEventListener('message', that.wheelHandler, true);

      const headers = {
        "Authorization": 'Bearer ' + localStorage.getItem('signature'),
        "App-Agent": 'tpl',
        "domain": JSON.parse(localStorage.getItem('authInfo')).domain,
      };
      that.sharedService.login(headers);

      this.reload();

    }
  }


  private reload() {

    sessionStorage.setItem('userInput', "");
    setTimeout(() => {
      window.location.reload();
    }, 500);

  }



  public accountInput(id, pw) {
    if (id != '' && pw != '')
      this.loginDisabled = false;
    else
      this.loginDisabled = true;
  }

  public keyDownFunction(e, id, pw, token) {
    if (e.which == 13 || e.keyCode == 13) {
      if (id != '' && pw != '' && typeof token === "undefined") {
        this.getTourPlan(id, pw);
      }
      else {
        e.preventDefault();
        let controls: any;
        controls = e.srcElement.form.getElementsByTagName('INPUT');
        var setFocusOnNext = false;
        for (var index = 0; index < controls.length; index++) {
          var element = controls[index];
          if (setFocusOnNext) {
            element.focus();
            return;
          }
          if (element === e.srcElement) setFocusOnNext = true;
        }
      }
    }
  }

  filterDomains(filterVal: any) {
    let that = this;

    let selectedDomain = this.domains.filter((item) => item.authurl == filterVal);
    localStorage.setItem('authInfo', JSON.stringify(selectedDomain[0]));

    that.authurl = selectedDomain[0] ? selectedDomain[0].authurl : false;
  }

}



// WEBPACK FOOTER //
// ./src/app/login.component.ts